import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { UserStatusRespawnStyled } from "./styled/UserStatusRespawnStyled";
import BinIcon from "../../../components/icon/IconWrapped";
import UserStatusCashbackClickInfo from "./UserStatusCashbackClickInfo";
import amountFormat from "../../../utils/amountFormat";

interface IUserStatusCashbackProps {
    amount: number;
}

function UserStatusCashback(props: IUserStatusCashbackProps) {
    const { getLangPath } = useLangContext();

    return <UserStatusCashbackClickInfo>
        <UserStatusRespawnStyled className={'inactive'}>
            <BinIcon name={'IcCashback'} size={32} className={'mb-2'}/>
            <div
                className={'text-secondary font-size-14'}>{getLangPath('user_statuses.cashback.title')}&nbsp;<span className={'text-primary'}>{amountFormat(props.amount, 1, null, false, {
                currencyAfter: '%'
            })}</span> <BinIcon
                name={'IcMoveRight'}/></div>
        </UserStatusRespawnStyled>
    </UserStatusCashbackClickInfo>;
}

export default UserStatusCashback;
